// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3s1N0","cell":"ColumnAccessor_cell__3aQfL","firstCellAccent":"ColumnAccessor_firstCellAccent__1Q05N"};